import { useEffect, useState } from "react";

/** Height of the on-screen keyboard, from the visual viewport. iPadOS does
 *  not shrink the layout viewport when the keyboard appears, so a fixed
 *  bottom bar would sit behind it; this lifts the bar by the covered height. */
export function useKeyboardInset(): number {
  const [inset, setInset] = useState(0);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const update = () => {
      const covered = window.innerHeight - vv.height - vv.offsetTop;
      setInset(Math.max(0, Math.round(covered)));
    };
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    update();
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, []);
  return inset;
}
